import { atom } from 'recoil';
import { LandmarkPair } from '~/domain/landmark/landmark';

export const landmarkPairListState = atom<LandmarkPair[]>({
    key: 'landmarkPairListState',
    default: [],
});

export const selectedLandmarkPairState = atom<string | null>({
    key: 'selectedLandmarkPairState',
    default: null,
});

export const focusedLandmarkHalfState = atom<'fixed' | 'moving' | null>({
    key: 'focusedLandmarkHalfState',
    default: null,
});

export const draggingLandmarkPairState = atom<string | null>({
    key: 'draggingLandmarkPairState',
    default: null,
});
